import { render } from "./editcategory.vue?vue&type=template&id=4d082225&scoped=true"
import script from "./editcategory.vue?vue&type=script&lang=js"
export * from "./editcategory.vue?vue&type=script&lang=js"

import "./editcategory.vue?vue&type=style&index=0&id=4d082225&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d082225"]])

export default __exports__